export default "/images/vendor/flag-icons/flags/4x3/cl.svg?107ef3fb7d1ea271cc2e350757fa3230";